import React, { useContext } from "react";
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
import ErrorHandler from "../components/errors/ErrorHandler";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Logout from "../pages/Logout";
import Activation from "../pages/Activation";
import Registration from "../pages/Registration";
import PageNotFound from "../components/PageNotFound";
import Layout from "../components/Layout"; 
import ChangePassword from "../pages/ChangePassword";
import ResetPassword from "../pages/ResetPassword";
import { AuthContext } from "../contexts/AuthContext";
import { projectBasename } from "../constants";
import { useTranslation } from "react-i18next";
import StaticPage from "../pages/StaticPage";

const Router = () => {
  const { AuthContextState } = useContext(AuthContext);
  const { isAuthenticated, idApp } = AuthContextState;
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const authRequestSearch = typeof window !== "undefined" ? window.location.search : "";
  const activeSessionPath = `/${currentLang}/logout${authRequestSearch || `?appId=${idApp}`}`;

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        {/* Root Layout */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/:lang/privacy_policy" element={<StaticPage pageKey="privacyPolicy"/>}/>
          <Route path="/:lang/terms_and_conditions" element={<StaticPage pageKey="userAgreement"/>}/>
          <Route path="/:lang/user_agreement" element={<StaticPage pageKey="userAgreement"/>}/>
          <Route path="/:lang/service_terms" element={<StaticPage pageKey="serviceTerms"/>}/>
          <Route
            path="/:lang/logout"
            element={<Logout />}
            errorElement={<ErrorHandler />}
          />
          <Route
            path="/:lang/registration"
            element={
              <ProtectedRoute isAuth={isAuthenticated} redirectPath={`/${currentLang}/logout?appId=${idApp}`}>
                <Registration />
              </ProtectedRoute>
            }
            errorElement={<ErrorHandler />}
          />
          <Route
            path="/:lang/activation"
            element={
              <ProtectedRoute isAuth={isAuthenticated} redirectPath={`/${currentLang}/logout?appId=${idApp}`}>
                <Activation />
              </ProtectedRoute>
            }
            errorElement={<ErrorHandler />}
          />
          <Route
            path="/:lang/login"
            element={
              <ProtectedRoute isAuth={isAuthenticated} redirectPath={activeSessionPath}>
                <Login />
              </ProtectedRoute>
            }
            errorElement={<ErrorHandler />}
          />
          <Route
            path="/:lang/forgot"
            element={
              <ProtectedRoute isAuth={isAuthenticated} redirectPath={`/${currentLang}/logout?appId=${idApp}`}>
                <ResetPassword />
              </ProtectedRoute>
            }
            errorElement={<ErrorHandler />}
          />
          <Route
            path="/:lang/change-password"
            element={
              <ProtectedRoute isAuth={isAuthenticated} redirectPath={`/${currentLang}/logout?appId=${idApp}`}>
                <ChangePassword />
              </ProtectedRoute>
            }
            errorElement={<ErrorHandler />}
          />
        </Route>

        {/* Page Not Found */}
        <Route path="*" element={<PageNotFound />} />
      </>
    ),
    { basename: projectBasename }
  );

  return <RouterProvider router={router} />;
};

export default Router;
